import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { InspectionPoint } from '../../shared/models/index';

@Component({
    selector: 'new-point',
    templateUrl: './new.component.html',
    standalone: false
})
export class NewPointComponent implements OnInit {
  public point: InspectionPoint = new InspectionPoint('', '', '');
  @Input() public processing;
  @Output() public toggleCreatePoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  editForm: UntypedFormGroup;

  constructor() {}

  ngOnInit(): void {}

  public save() {
    this.toggleCreatePoint.emit(this.point);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
